/*
 * Refreshes Hydeline's Quickship / Made-To-Order swatch grouping when the
 * user changes a non-color option (typically size). This is the minimal
 * sibling to cylindo-viewer.js for Hydeline products that don't have a SKU
 * (and therefore don't load cylindo-viewer.js, which normally piggybacks
 * the swatch refresh onto its existing section reload).
 *
 * Quickship status is variant-level, so the grouping depends on the
 * currently selected size. When size changes, we refetch the product
 * section for the new variant and swap in the freshly-rendered color
 * fieldsets so the grouping reflects the new size.
 *
 * Loaded conditionally in main-product.liquid for Hydeline products that
 * have an empty cylindo_code (i.e. no variant SKU).
 */
(function () {
  'use strict';

  function setup() {
    var productData = null;
    var productJsonEl = document.querySelector('[data-product-json]');
    if (productJsonEl) {
      try { productData = JSON.parse(productJsonEl.textContent); } catch (e) {}
    }

    var lastVariantId = findCurrentVariantId();

    function getSectionInfo() {
      var el =
        document.querySelector('variant-selects, variant-radios') ||
        document.querySelector('[id^="variant-selects-"], [id^="variant-radios-"]');
      if (!el) return null;
      var sectionId = el.dataset.section || el.dataset.sectionId ||
                       (el.id ? el.id.replace(/^variant-(selects|radios)-/, '') : '');
      var productUrl = el.dataset.url || el.dataset.productUrl ||
                       window.location.pathname.split('?')[0];
      return { sectionId: sectionId, productUrl: productUrl };
    }

    // Read the currently-checked radios out of each option fieldset and
    // find the matching variant in the product JSON ourselves. This
    // avoids the timing problem where input[name="id"] is updated by the
    // theme AFTER our change handler runs — radios on the other hand are
    // already updated by the browser BEFORE the change event fires, so
    // they always reflect the live selection.
    function findCurrentVariantId() {
      if (!productData || !productData.variants) return null;

      var selected = [null, null, null];
      var fieldsets = document.querySelectorAll('fieldset[data-index]');
      for (var i = 0; i < fieldsets.length; i++) {
        var idxStr = fieldsets[i].dataset.index || '';
        if (idxStr.indexOf('option') !== 0) continue;
        var idx = parseInt(idxStr.slice(6), 10) - 1;
        if (idx < 0 || idx > 2) continue;
        var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
        if (checked) selected[idx] = checked.value;
      }

      for (var v = 0; v < productData.variants.length; v++) {
        var variant = productData.variants[v];
        if (selected[0] != null && variant.option1 !== selected[0]) continue;
        if (selected[1] != null && variant.option2 !== selected[1]) continue;
        if (selected[2] != null && variant.option3 !== selected[2]) continue;
        return variant.id;
      }
      return null;
    }

    function refreshColorFieldsets(variantId) {
      var info = getSectionInfo();
      if (!info || !info.sectionId) return;

      var fetchUrl = info.productUrl + '?variant=' + variantId + '&section_id=' + info.sectionId;

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshFieldsets = doc.querySelectorAll('.product-form__input--color');
          var currentFieldsets = document.querySelectorAll('.product-form__input--color');
          var pairs = Math.min(freshFieldsets.length, currentFieldsets.length);
          for (var i = 0; i < pairs; i++) {
            currentFieldsets[i].outerHTML = freshFieldsets[i].outerHTML;
          }
        })
        .catch(function (e) { console.warn('hydeline swatch refresh failed', e); });
    }

    // Listen for non-color option changes (e.g. size). We deliberately skip
    // changes inside the color fieldset itself — those only swap one
    // upholstery for another within the same size, which doesn't change
    // the Quickship/MTO grouping and would cause a wasteful refetch.
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.type !== 'radio') return;
      if (!input.dataset.optionValueId) return;

      var fieldset = input.closest('fieldset');
      if (!fieldset) return;
      if (fieldset.classList.contains('product-form__input--color')) return;

      var currentId = findCurrentVariantId();
      if (!currentId || String(currentId) === String(lastVariantId)) return;
      lastVariantId = currentId;
      refreshColorFieldsets(currentId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
